"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStylesUtils = void 0;
var _react = require("react");
var _CetComponentsProvider = require("../providers/CetComponentsProvider");
const BASE_FONT_SIZE = 10;
const useStylesUtils = contextValues => {
  let {
    rootFontSize = 10,
    direction = 'rtl'
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  //on first load this hooks is being called before context is initialized
  rootFontSize = contextValues?.rootFontSize ?? rootFontSize;
  direction = contextValues?.language ? _CetComponentsProvider.rtlLanguages.includes(contextValues.language) ? 'rtl' : 'ltr' : direction;
  const pxToRem = (0, _react.useCallback)(px => {
    const baseProportion = rootFontSize / BASE_FONT_SIZE;
    const rem = px / BASE_FONT_SIZE;
    return rem / baseProportion + 'rem';
  }, [rootFontSize]);
  const setStartDirection = px => {
    let left;
    let right;
    if (direction === 'rtl') {
      left = 'auto';
      right = pxToRem(px);
    } else {
      right = 'auto';
      left = pxToRem(px);
    }
    return {
      left,
      right
    };
  };
  const setEndDirection = px => {
    let left;
    let right;
    if (direction === 'rtl') {
      right = 'auto';
      left = pxToRem(px);
    } else {
      left = 'auto';
      right = pxToRem(px);
    }
    return {
      left,
      right
    };
  };
  const getMeasurement = (0, _react.useCallback)(measurement => {
    return isNaN(Number(measurement)) ? measurement : pxToRem(Number(measurement));
  }, [pxToRem]);
  const scrollProps = slideBy => {
    const px = slideBy === 'scroll' ? 0 : 7;
    return {
      '&::-webkit-scrollbar': {
        width: pxToRem(px),
        height: pxToRem(px)
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: pxToRem(10),
        backgroundColor: '#ececf0'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#7f7f90',
        outline: '1px solid #ececf0',
        borderRadius: pxToRem(10)
      }
    };
  };
  const maskProps = isOpen => {
    return {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      pointerEvents: 'all',
      background: 'rgba(0, 0, 0, 0.6)',
      transition: 'opacity 0.3s ease-in-out',
      opacity: isOpen ? 1 : 0,
      zIndex: 9999
    };
  };
  const fontSizeProps = size => {
    let fontSize;
    switch (size) {
      case 'x-small':
        fontSize = pxToRem(13);
        break;
      case 'small':
        fontSize = pxToRem(14);
        break;
      case 'medium':
        fontSize = pxToRem(16);
        break;
      case 'large':
        fontSize = pxToRem(18);
        break;
      case 'x-large':
        fontSize = pxToRem(24);
        break;
      case 'stretch':
        fontSize = 'initial';
    }
    return {
      fontSize
    };
  };
  const borderRadiusProps = borderRadius => {
    let borderRadiusObj = {}; //todo: fix type
    if (borderRadius) {
      for (const [key, value] of Object.entries(borderRadius)) {
        borderRadiusObj[key] = getMeasurement(value);
      }
      return borderRadiusObj;
    }
    return {};
  };
  const getElementHeight = size => {
    switch (size) {
      case 'x-small':
        return pxToRem(20);
      case 'small':
        return pxToRem(28);
      case 'medium':
        return pxToRem(36);
      case 'large':
        return pxToRem(40);
      case 'x-large':
        return pxToRem(48);
      case 'stretch':
        return '100%';
    }
  };
  return {
    pxToRem,
    setStartDirection,
    setEndDirection,
    getMeasurement,
    scrollProps,
    maskProps,
    borderRadiusProps,
    fontSizeProps,
    getElementHeight
  };
};
exports.useStylesUtils = useStylesUtils;